import axios from "axios";

const state = () => ({
    regiones: [],
    regionSeleccionada: null,
    selectedPlano: null,
    regionNueva: null,
    stateSelectedNode: null,

    // categorías del cliente actual y { id_armario: id_categoria }
    categorias: [],
    categoriaPorArmario: {},

    // catálogo global de carpetas de documentos (incluye las desactivadas)
    carpetas: [],
});
const getters = {
    categoriaDeArmario: (state) => (id_armario) => {
        const id_categoria = state.categoriaPorArmario[id_armario];
        return id_categoria ? state.categorias.find((c) => c.id === id_categoria) || null : null;
    },
};
const mutations = {
    setSelectedPlano(state, plano) {
        state.selectedPlano = plano;
    },
    setRegionNueva(state, region) {
        state.regionNueva = region;
    },
    setCategorias(state, { categorias, asignaciones }) {
        state.categorias = categorias || [];
        state.categoriaPorArmario = Object.fromEntries(
            (asignaciones || []).map((a) => [a.id_armario, a.id_categoria])
        );
    },
    setCarpetas(state, carpetas) {
        state.carpetas = carpetas || [];
    },
    setCategoriaArmario(state, { id_armario, id_categoria }) {
        const copia = { ...state.categoriaPorArmario };
        if (id_categoria) copia[id_armario] = id_categoria;
        else delete copia[id_armario];
        state.categoriaPorArmario = copia;
    },
};

const actions = {
    async fetchRegiones({ state }, planoId) {
        try {
            const res = await state.myAxios.get(`api/planos/${planoId}/regiones`);
            state.regiones = res.data.map((r) => ({
                id: r.id_region,
                x: parseFloat(r.x),
                y: parseFloat(r.y),
                nombre: r.nombre_region
            }));
        } catch (error) {
            console.error("Error fetching regiones:", error);
        }
    },
    async setRegionSeleccionada({ state }, region) {
        state.regionSeleccionada = region;
    },
    async setSelectedPlano({ commit }, plano) {
        commit('setSelectedPlano', plano);
    },
    async setRegionNueva({ commit }, region) {
        commit('setRegionNueva', region);
    },
    async setSelectedNode({ state }, node) {
        state.stateSelectedNode = node;
    },
    setCategorias({ commit }, payload) {
        commit('setCategorias', payload);
    },
    setCategoriaArmario({ commit }, payload) {
        commit('setCategoriaArmario', payload);
    },
    async cargarCarpetas({ commit }) {
        try {
            const { data } = await axios.get(`${process.env.VUE_APP_LOCAL_BASE_URL}/api/nodejs/clientes/carpetas`);
            commit('setCarpetas', data.carpetas);
        } catch (error) {
            console.error("Error al cargar las carpetas:", error);
        }
    },


};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
